<template>
  <v-container>
    <div class="error-page">
      <h3 class="text-h3 text-center">
        404
      </h3>
      <h3 class="text-h3 text-center">
        NOT FOUND
      </h3>
    </div>
    <v-btn
      x-large
      outlined
      block
      class="primary"
      @click="takeMeHome()"
    >
      Take me back
    </v-btn>
  </v-container>
</template>

<script>

export default {
  name: 'ErrorPage',
  methods: {
    takeMeHome () {
      this.$router.push({ name: 'HomePage' });
    },
  },
};
</script>

<style lang="css" scoped>

.error-page {
  text-align: center;
  width: 300px;
  height: 300px;
  margin: auto;
  margin-top: 25%;
}
</style>
